import { Dialog } from '@elementary/common-ui/components';
import type { IncidentTicketRow } from '../types';

type Props = {
  ticket: IncidentTicketRow;
  isUnlinking: boolean;
  onClose: () => void;
  onConfirm: (serviceTicketId: string) => Promise<unknown>;
};

const UnlinkIncidentTicketDialog = ({
  ticket,
  isUnlinking,
  onClose,
  onConfirm,
}: Props) => (
  <Dialog
    open
    title="Unlink ticket"
    confirmText="Unlink"
    variant="error"
    isLoading={isUnlinking}
    closeOnBackdropClick={!isUnlinking}
    onClose={onClose}
    onConfirmButtonClick={() => {
      onConfirm(ticket.service_ticket_id)
        .then(() => onClose())
        .catch(() => {});
    }}
    message="Are you sure you want to unlink this ticket from the incident?"
  />
);

export default UnlinkIncidentTicketDialog;
